import React, { Component } from "react";
import { Link } from "react-router-dom";
import Button from "./Button";
import mainSlider1 from "../images/main-slider-1.jpg";
import mainSlider1Sm from "../images/main-slider-1_sm.jpg";
import mainSlider2 from "../images/ktp1.jpg";
import soberEyeBack from "../images/sobe-eye-back.webp";
import soberEyeLogo from "../images/sober-eye-logo.jpg";
import rigidRoboticsLogo from "../images/rigidlogo-rgb.png";
import aibackground from "../images/AIbackground.jpg";
import aibackgroundsm from "../images/AIbackground_sm.jpg";
import highprecisionbc from "../images/highprecisionbc.jpg";
import highprecisionbcSm from "../images/highprecisionbc_sm.jpg";
import LogoImagingMeglab from "../images/logo-imagine-header.png";
import meglabbc from "../images/meglabbc.jpg";
import meglabbcsm from "../images/meglabbc_sm.jpg";

const slides = [
  {
    link: "Система предотвращения столкновений",
    to: "prevent-collision",
    title:
      "Высокоточное решение для предотвращения столкновений.",
    desc:
      "Активация «Точности безопасности», потому что ложные тревоги убивают",
    img: mainSlider1,
    smImg: mainSlider1Sm,
    logo: rigidRoboticsLogo
  },
  {
    link: "Система мониторинга персонала",
    to: "sober-eye",
    title:
      "Снижение количества несчастных случаев на рабочем месте с инновационным решением по безопасности.",
    desc:
      "Оценивайте риск усталости, алкоголя и наркотиков на рабочем месте, когда это наиболее важно",
    img: soberEyeBack,
    smImg: soberEyeBack,
    logo: soberEyeLogo
  },
  {
    link:
      "Решение для оптимизации подземных горных работ и повышения безопасности персонала",
    to: "meglab",
    img: meglabbc,
    smImg: meglabbcsm,
    logo: LogoImagingMeglab
  },
  {
    link:
      "Высокоточное позиционирование, направление и 3D-ориентация",
    to: "precision-position",
    title: "Режим «Точной добычи»",
    desc:
      "Высокоточное позиционирование как эффективная инфраструктура всего парка",
    img: highprecisionbc,
    smImg: highprecisionbcSm,
    logo: rigidRoboticsLogo
  },
  {
    link: "Изготовление электрооборудования",
    to: "electrics",
    img: mainSlider2
  },
  {
    link:
      "Продвинутая аналитика и искусственный интеллект в горном деле",
    to: "aianalytics",
    title:
      "Новая эра принятия решений на основе искусственного интеллекта",
    desc:
      "Помогаем оценить и внедрить новые технологии в горном деле",
    img: aibackground,
    smImg: aibackgroundsm,
    logo: rigidRoboticsLogo
  }
];

export default class SimpleSlider extends Component {
  state = { activeSlide: 0 };

  componentDidMount() {
    this.slideTimer = window.setInterval(this.showNextSlide, 5000);
  }

  componentWillUnmount() {
    window.clearInterval(this.slideTimer);
  }

  showNextSlide = () => {
    this.setState(({ activeSlide }) => ({
      activeSlide: (activeSlide + 1) % slides.length
    }));
  };

  showSlide = activeSlide => {
    this.setState({ activeSlide });
  };

  render() {
    return (
      <div className="carrousel_wrapper" aria-roledescription="carousel">
        {slides.map((item, index) => (
          <div
            className={`hero-slide ${this.state.activeSlide === index ? "is-active" : ""}`}
            key={item.to}
            style={{
              backgroundImage: `url(${item.img})`,
              "--mobile-background": `url(${item.smImg || item.img})`
            }}
          >
            <div className="carrousel_image">
              <div className="columns">
                <div className="column hero-left-column">
                  <div className="hero-left-desc">
                    {item.logo && <img src={item.logo} className="sober-eye-logo" alt="" />}
                    <h1 className="hero-left-desc-h1-link fade-in">
                      {item.to && <Link to={item.to}>{item.link}</Link>}
                    </h1>
                    <h1 className="hero-left-desc-title">{item.title}</h1>
                    <p className="hero-left-desc-desc">{item.desc}</p>
                    <Button to={item.to} value="Подробнее" />
                  </div>
                </div>
                <div className="column hero-right-column" />
              </div>
            </div>
          </div>
        ))}
        <div className="hero-slider-dots">
          {slides.map((item, index) => (
            <button
              className={this.state.activeSlide === index ? "is-active" : ""}
              key={item.to}
              type="button"
              aria-label={`Show slide ${index + 1}`}
              onClick={() => this.showSlide(index)}
            />
          ))}
        </div>
      </div>
    );
  }
}
